import React from 'react';
import PropTypes from 'prop-types';
import navigationService from '../../services/NavigationService';
import { t } from '../../services/i18nService';
import styles from './options.scss';
import backgroundAudioService from '../../services/BackgroundAudioService';
import storeManager from '../../store/StoreManager';
import sessionActions from '../../actions/SessionActions';

class OptionsButton extends React.Component {
    handleNavigateToOptions() {
        storeManager.dispatch(sessionActions.toggleInvigilatorAuthorized(false));
        navigationService.navigateToOptions();
    }

    render() {
        return (
            <button
                className={styles.optionsButton}
                onClick={this.handleNavigateToOptions}
            >
                <span className="sr-only">{t('options.backToOptionsList')}</span>
                <i className="fa fa-chevron-left" aria-hidden="true" /> {t('options.optionsHeader')}
            </button>
        );
    }
}

class BackToDashboardButton extends React.Component {
    handleNavigateToDashboard() {
        navigationService.navigateToDashboardTicket();
    }

    render() {
        return (
            <button
                className={styles.optionsButton}
                onClick={this.handleNavigateToDashboard}
            >
                <span className="sr-only">{t('options.backToDashboard')}</span>
                <i className="fa fa-chevron-left" aria-hidden="true" /> {t('options.dashboardLabel')}
            </button>
        );
    }
}

class InvigilatorOptionsButton extends React.Component {
    constructor(props) {
        super(props);
        this.keyPress = (event) => {
            if (event.keyCode === 8) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
        // Storing function locally in the class because .bind() returns
        // a new function when bound directly in the eventListener
        this.keyPressHandler = this.keyPress.bind(this);
        document.addEventListener('keydown', this.keyPressHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.keyPressHandler);
    }

    handleNavigateToInvigilatorOptions() {
        backgroundAudioService.resume();
        navigationService.navigateToInvigilatorOptions();
    }

    render() {
        return (
            <button
                className={styles.optionsButton}
                onClick={this.handleNavigateToInvigilatorOptions}
            >
                <span className="sr-only">{t('options.backToOptionsList')}</span>
                <i className="fa fa-chevron-left" aria-hidden="true" /> {t('options.optionsHeader')}
            </button>
        );
    }
}

class ExitButton extends React.Component {
    render() {
        return (
            <button
                className={styles.exitButton}
                id="exitOptionsMenuButton"
                onClick={navigationService.exitFromOptions}
            >
                <span className="sr-only">{t('options.btnLabelExitFromOptions')}</span>
                <i className="fa fa-close fa-3" aria-hidden="true" />
            </button>
        );
    }
}

class OptionsTopBar extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        showExitButton: PropTypes.bool,
        showOptionsButton(props) {
            if (props.showOptionsButton && props.showBackToDashboardButton) {
                return new Error(
                    'Only one of components (OptionsButton or BackToDashboardButton) can be used in the "OptionsTopBar" at the same time'
                );
            }
            return false;
        },
        showInvigilatorOptionsButton: PropTypes.bool,
        showBackToDashboardButton(props) {
            if (props.showOptionsButton && props.showBackToDashboardButton) {
                return new Error(
                    'Only one of components (OptionsButton or BackToDashboardButton) can be used in the "OptionsTopBar" at the same time'
                );
            }
            return false;
        },
    };

    componentDidMount() {
        this.h1.focus();
    }

    componentDidUpdate() {
        this.h1.focus();
    }

    render() {
        return (
            <div className={styles.optionsTopBar} role="banner">
                {
                    this.props.showOptionsButton && !this.props.showBackToDashboardButton
                        ? <OptionsButton />
                        : null
                }

                {
                    this.props.showBackToDashboardButton && !this.props.showOptionsButton
                        ? <BackToDashboardButton />
                        : null
                }

                {
                    this.props.showInvigilatorOptionsButton
                        ? <InvigilatorOptionsButton />
                        : null
                }

                <div className={styles.title}>
                    <h1 tabIndex="-1" ref={(h1) => { this.h1 = h1; }}>{this.props.title}</h1>
                </div>

                {
                    this.props.showExitButton === false ?
                        null
                        :
                        <ExitButton />

                }

            </div>
        );
    }
}

export default OptionsTopBar;
